import React, { useEffect, useState } from "react";
import "./ProfileImageComponent.css";
import { useDispatch } from "react-redux";
import LMSButton from "../../LMSButton/LMSButton";
import lmsToast from "../../CustomToastifier/CustomToastifier";
import { putDataFormDataWithNoidPf } from "../../../Services/ProfileServices";
import {
  postImage,
  userMgmtService,
  getUserImage,
} from "../../../Services/EndPoints";
import { fetchProfileData } from "../../../CentralStore/ExportLMSTable/dataSlice";

export default function ProfileImageComponent({ profileData }) {
  const dispatch = useDispatch();
  const [fileObj, setFileObj] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    setFileObj(profileData?.photo);
  }, [profileData]);

  const validFileTypes = ["image/png", "image/jpg", "image/jpeg"];
  const handleChange = (event) => {
    const formData = new FormData();
    const file = event.target.files[0];

    if (file && validFileTypes.includes(file.type)) {
      if (file.size < 15000000) {
        setFileObj(file);
        formData.append("photo", file);
        putDataFormDataWithNoidPf(postImage, formData)
          .then((res) => {
            setTimeout(() => {
              lmsToast({
                toasterType: "success",
                msg: "Successfully Profile Picture Changed",
              });
            }, 200);
            dispatch(fetchProfileData());
          })
          .catch((err) => {
            console.log(err);
          });

        setErrorMsg("");
      }
    } else {
      setErrorMsg("Invalid file type. Please select an image.");
    }
  };

  const handleClick = () => {
    const fileInputTriger = document.getElementById("file_upload");
    if (fileInputTriger) {
      fileInputTriger.click();
    }
  };

  return (
    <div className="image_container--maindiv">
      <div className="profile_image">
        <img
          src={
            fileObj?.id
              ? `${userMgmtService}${getUserImage}${fileObj.id}`
              : fileObj && URL.createObjectURL(fileObj)
          }
          alt=""
          className="profile_image--image"
          width="100%"
          height="100%"
        />
        {errorMsg && <div className="error__message w-100">{errorMsg}</div>}
        <div className="edit-profile_icon">
          <LMSButton label="Edit Photo" onClick={handleClick} />
          <input
            id="file_upload"
            type="file"
            accept="image/*"
            name="file_upload"
            style={{ display: "none" }}
            onChange={(event) => {
              handleChange(event);
            }}
          />
        </div>
        <div className="user-profile_detail">
          <div>
            {`${profileData?.firstName} ${
              profileData?.middleName ? profileData?.middleName : ""
            } ${profileData?.lastName}`}
          </div>
          <div>{profileData?.username}</div>
          <div>{profileData?.phone}</div>
        </div>
      </div>
    </div>
  );
}
